import * as React from 'react';
import {useMemo} from 'react';
import * as _ from 'lodash';
import {getListingsPageHref} from '../../../crazyEditor/containers/Main/utils';
import {EBayAccounts as EBayAccountsData} from '../AccountPageSectionsData';
import ChannelAccounts from './ChannelAccounts';
import {useSelector} from 'react-redux';
import {getEbayAccounts} from '../../../Layout/MyAccountLayout/ApplicationLayoutSelectors';
import {Channels} from 'cl-api';

const EBayAccounts: React.FunctionComponent = () => {
  const rawAccounts = useSelector(getEbayAccounts);
  const accounts = useMemo(
    () =>
      _.map(rawAccounts, ({UserID, tokenExpirationDate, quantitySyncEnabled}, index) => {
        return {
          id: UserID,
          tokenExpirationDate,
          quantitySyncEnabled,
          listingsPageHref: getListingsPageHref(rawAccounts[index]),
        };
      }),
    [rawAccounts]
  );

  return <ChannelAccounts channel={Channels.EBay} accounts={accounts} />;
};

export default _.assign(EBayAccounts, EBayAccountsData);
